module.exports = __webpack_public_path__ + "img/Washi-tape-top-left.21ee4549.svg";